import React, { Component } from "react";

const AddButtonIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_1596_13084)">
        <circle cx="14.5" cy="14.5" r="11.5" fill="white" />
        <path d="M15 10V19" stroke="black" />
        <path d="M20 14L10 14" stroke="black" />
      </g>
      <defs>
        <filter
          id="filter0_d_1596_13084"
          x="0"
          y="0"
          width="29"
          height="29"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1596_13084"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1596_13084"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

AddButtonIcon.defaultProps = {
  width: "29",
  height: "29",
  fill: "none",
};

export default AddButtonIcon;
